import { ApiReportStepStatus } from '@/api/types/models.types';

export const getStatusText = (status: ApiReportStepStatus) => {
  switch (status) {
    case 'krok 1':
      return 'Zlecenie oczekuje na przyjęcie';
    case 'krok 2':
      return 'Zlecenie przyjęte do realizacji';
    case 'krok 3':
      return 'Dzień oględzin pojazdu';
    case 'krok 4':
      return 'Generowanie raportu';
    case 'krok 5':
      return 'Zamówiony raport już na ciebie czeka!';
    default:
      return 'Status nieznany';
  }
};

export const getStatusDescription = (status: ApiReportStepStatus) => {
  switch (status) {
    case 'krok 1':
      return 'Twoje zamówienie zostało zarejestrowane w naszym systemie i wkrótce rozpocznie się jego realizacja. Obecnie przygotowujemy je do dalszych czynności, aby cały proces przebiegł sprawnie i bez opóźnień. Na tym etapie masz jeszcze możliwość zmiany pojazdu do sprawdzenia.';
    case 'krok 2':
      return 'Twoje zamówienie zostało przyjęte przez naszego koordynatora i jest w trakcie przygotowania do realizacji. Weryfikujemy wszystkie szczegóły, aby zapewnić dokładność i sprawny przebieg dalszych działań. Koordynator czuwa nad procesem, aby wszystko przebiegło zgodnie z planem, a oględziny zostały przeprowadzone terminowo. Już wkrótce nasz Specjalista zajmie się dokładną oceną pojazdu zgodnie z Twoim zleceniem.';
    case 'krok 3':
      return `Dziś odbywają się oględziny Twojego pojazdu. Nasz specjalista sprawdza jego stan techniczny, historię oraz ewentualne usterki.<br /><br />Prosimy mieć na uwadze, że dokładna godzina rozpoczęcia oględzin może się nieznacznie różnić ze względu na czynniki niezależne, takie jak warunki pogodowe, dostępność pojazdu czy lokalne okoliczności. Dokładamy wszelkich starań, aby cały proces przebiegł sprawnie i bez opóźnień.`;
    case 'krok 4':
      return `Oględziny pojazdu zostały zakończone, a nasz zespół pracuje nad stworzeniem szczegółowego raportu. Obecnie gromadzimy i analizujemy wszystkie zebrane dane, aby przygotować dokument, który w przejrzysty sposób przedstawi stan techniczny pojazdu wraz z jego wszystkimi niuansami.<br /><br />Dbamy o to, aby każdy element raportu był dokładny i klarowny, co pozwoli Ci podjąć świadomą decyzję.`;
    case 'krok 5':
      return `Twój raport jest gotowy! Szczegółowe oględziny pojazdu zostały zakończone, a Ty możesz teraz zapoznać się z wynikami.`;
    default:
      return '';
  }
};

export const getWhatNextDescription = (status: ApiReportStepStatus) => {
  switch (status) {
    case 'krok 1':
      return 'W kolejnym kroku koordynator rozpocznie organizację procesu sprawdzania pojazdu w Twoim zleceniu.';
    case 'krok 2':
      return 'Niebawem otrzymasz informację o terminie oględzin. W następnym kroku nasz ekspert uda się na miejsce, aby dokładnie sprawdzić stan techniczny wskazanego przez Ciebie pojazdu.';
    case 'krok 3':
      return `Wkrótce dowiesz się wszystkiego o stanie pojazdu! Przewidywany czas otrzymania raportu to najpóźniej kolejny dzień roboczy.`;
    case 'krok 4':
      return `Już wkrótce otrzymasz gotowy dokument, który obejmie wszystkie istotne szczegóły dotyczące pojazdu. Twój raport powinien być gotowy do końca najbliższego dnia roboczego. Otrzymasz powiadomienie, gdy będzie dostępny.
        <br />
        <br />
        Dziękujemy za cierpliwość!`;
    default:
      return null;
  }
};
